<div class="progresses-wrapper" (click)="onEmptyClick($event)">
  <ng-container *ngFor="let project of sortedProgresses; let i = index">
    <ng-container *ngIf="!project?.is_empty; else empty">
      <div class="project-progress" (click)="openTooltip(projectDetailElem, project)">
        <div
          *ngIf="dayCellWidth | async"
          class="project-progress__backg"
          [class.clicked]="project?.clicked"
          [style.width.px]="(dayCellWidth | async) * project?.a_length - (project?.a_length === 7 ? 4 : 3)">
          <div class="project-hover-overflow">
            <ng-container *ngFor="let progressDay of [].constructor(project.a_length); let i = index">
              <span
                class="progress-day-cell"
                (mouseout)="disableProgressCellHover()"
                (mouseover)="setProgressCellHover(project, i, $event)"
                [matTooltip]="getTooltip(project)"
                matTooltipPosition="above"
                [matTooltipClass]="'tooltip--new-line'">
                {{ i + 1 }}
              </span>
            </ng-container>
          </div>

          <!--        <span class="has-prev-week" *ngIf="project?.has_prev">-->
          <!--            <i class="icon icon-Arrow_ico"></i>-->
          <!--        </span>-->

          <div class="flex-row w-100 progress-hide-overflow">
            <div class="icon icon-Folder_ico"></div>

            <div class="row-flex--column">
              <div
                class="project-progress__name-container"
                [style.maxWidth.px]="(project?.a_length * (dayCellWidth | async)) / 1.3">
                <span
                  [style.maxWidth.px]="(project?.a_length * (dayCellWidth | async)) / 3"
                  class="text-bold text-ellipsis project-progress__name-container--name">
                  {{ project?.name }}
                </span>

                <span class="text-ellipsis"> ({{ project?.display_id }}) </span>

                <div class="project__status__container">
                  <div
                    class="project__status"
                    [matTooltip]="getStatusTooltipValue(project?.display_status) | translate"
                    [style.background-color]="getStatusColor(project?.display_status)"></div>

                  <div
                    *ngIf="project.display_status !== project.status"
                    class="project__status project__status--last"
                    [matTooltip]="getStatusTooltipValue(project.status) | translate"
                    [style.background-color]="getStatusColor(project.status)"></div>
                </div>
              </div>

              <ng-container *ngIf="project?.client?.name; else noSet">
                <div class="project-progress__client">
                  <span [style.maxWidth.px]="(project?.a_length * (dayCellWidth | async)) / 1.7" class="text-ellipsis">
                    {{ project?.client?.name }}
                  </span>
                </div>
              </ng-container>
            </div>
          </div>

          <!--        <span class="has-next-week" *ngIf="project?.has_next">-->
          <!--          <i class="icon icon-Arrow_ico"></i>-->
          <!--        </span>-->
        </div>

        <div *ngIf="project?.is_empty">
          {{ project.index }}
        </div>
      </div>
    </ng-container>

    <ng-template #empty>
      <div (click)="onEmptyClick($event)" class="project-progress empty"></div>
    </ng-template>

    <project-detail-tooltip
      #projectDetailElem
      [item]="project"
      [hideActionBtns]="hideActionBtns"
      (onProjectDeleted)="onDeleteAction($event)"
      (onProjectEdited)="onEditAction($event)"
      (onMenuClose)="changeProgressColor()">
    </project-detail-tooltip>
  </ng-container>
</div>

<ng-container *ngIf="day['showMore']">
  <div class="expand--highlight" (click)="showAllProgresses(day, week, allProgresses); $event.stopPropagation()">
    +{{ day['showMore'] }} {{ 'More' | translate }}
  </div>
</ng-container>

<ng-container *ngIf="day['progressesLength'] > 2 && day['showMore'] === 0">
  <div class="expand--highlight" (click)="sortProgresses(allProgresses, day, week, true); $event.stopPropagation()">
    {{ 'Show less' | translate }}
  </div>
</ng-container>

<ng-template #noSet>
  <span class="no-set__value">
    {{ 'No set' | translate }}
  </span>
</ng-template>
